import {SET_PROFILE} from "./actionTypes";

export const setProfile = (content) => ({
  type: SET_PROFILE,
  payload: content
});
